
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/category",
      function () {
        return require("private-next-pages/[locale]/category/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/category"])
      });
    }
  